import { useEffect, useState } from "react"
import { useUpdatePrivacyMutation } from "../../../../../features/peopleApi"
import { useOtpRequestMutation, useOtpVerifyMutation } from "../../../../../features/privacyApi"
import { addBannerWithTimeout } from "../../../../lib/centralizedBanner/slice"
import { useAppDispatch } from "../../../../lib/redux/hooks"
import { CheckCircleIcon } from "../../../../ui/icons/checkCircle"
import Button from "../../../../ui/molecules/button"
import { PersonDTO } from "../dto"
import { ConfirmOtpModal } from "./confirmOtpModal"
import { SendOtpModal } from "./sendOtpModal"

export interface PersonPrivacyProps {
    section: "form" | "outcome"
    privacy?: boolean
    personId: string
    setLeadStep?: (step: number) => void
    person?: PersonDTO
}

export function PrivacyComponent(props: PersonPrivacyProps) {
    const [sendOtpModal, setSendOtpModal] = useState(false)
    const [confirmOtpModal, setConfirmOtpModal] = useState(false)
    const dispatch = useAppDispatch()
    const [stepOutcome, setStepOutcome] = useState(1);
    const [isActive, setIsActive] = useState(false);
    const [otpRequest, { isLoading: isOtpRequestLoading }] = useOtpRequestMutation();
    const [otpVerify, { isLoading: isOtpVerifyLoading, isError: isOtpVerifyError, isSuccess: isOtpVerifySuccess, }] = useOtpVerifyMutation();
    const [updatePerson] = useUpdatePrivacyMutation()

    const [phone, setPhone] = useState<string | null>(null);

    useEffect(() => {
        setPhone(props.person?.phone ?? null);
    }, [props.person]);

    useEffect(() => {
        if (props.section === "outcome") {
            setIsActive(true);
        } else {
            setIsActive(sendOtpModal || confirmOtpModal);
        }
    }, [props.section, sendOtpModal, confirmOtpModal]);

    const handleSendOtp = async (phone: string) => {
        if (!isActive) return;
        try {
            await otpRequest(phone ?? "").unwrap();
            if (props.section === "outcome") {
                setStepOutcome(2)
            } else {
                setSendOtpModal(false)
                setConfirmOtpModal(true)
            }
        } catch (error) {
            if (props.section === "outcome")
                props.setLeadStep?.(1)
            else
                setSendOtpModal(false)
            dispatch(addBannerWithTimeout({
                message: "Errore nell'invio dell'OTP",
                variant: "error"
            }))
        }
    }

    const handleVerifyOtp = async (phoneNumber: string, code: string) => {
        if (!isActive) return;
        try {
            await otpVerify({ phoneNumber, code }).unwrap();
            handlePrivacyUpdate();
        } catch (error) {
            if (props.section === "outcome")
                props.setLeadStep?.(1)
            else
                setConfirmOtpModal(false)
            dispatch(addBannerWithTimeout({
                message: "Errore nella verifica dell'OTP",
                variant: "error"
            }))
        }
    }

    const handlePrivacyUpdate = async () => {
        try {
            await updatePerson({
                id: props.person?.id || "",
            }).unwrap();
            if (props.section === "outcome") {
                props.setLeadStep?.(4)
            } else {
                setSendOtpModal(false)
                setConfirmOtpModal(false)
            }
            dispatch(addBannerWithTimeout({
                message: "Privacy aggiornata con successo",
                variant: "success"
            }));
        } catch (error) {
            if (props.section === "outcome")
                props.setLeadStep?.(1)
            else
                setConfirmOtpModal(false)
            dispatch(addBannerWithTimeout({
                message: "Errore nell'aggiornamento della privacy",
                variant: "error"
            }));
        }
    };

    // useEffect(() => {
    //     if (!isActive) return;

    //     let timeoutId: NodeJS.Timeout;
    //     if (otpState.otpRequestStatus === "failed") {
    //         if (props.section === "outcome")
    //             props.setLeadStep?.(1)
    //         else
    //             setSendOtpModal(false)
    //         timeoutId = setTimeout(() => {
    //             dispatch(setOtpRequestStatus("idle"));
    //         }, 5000);
    //     }
    //     if (otpState.otpRequestStatus === 'successfully') {
    //         if (props.section === "outcome") {
    //             setStepOutcome(2)
    //         } else {
    //             setSendOtpModal(false)
    //             setConfirmOtpModal(true)
    //         }
    //         dispatch(setOtpRequestStatus("idle"));
    //     }
    //     return () => {
    //         if (timeoutId) {
    //             clearTimeout(timeoutId);
    //         }
    //     };
    // }, [otpState.otpRequestStatus, isActive, props.section]);



    // useEffect(() => {

    //     let timeoutId: NodeJS.Timeout;
    //     if (otpState.otpVerifyStatus === 'successfully') {
    //         dispatch(setOtpVerifyStatus("idle"));



    //         handleSubmit();
    //         timeoutId = setTimeout(() => {
    //         }, 5000);
    //     }
    //     return () => {
    //         if (timeoutId) {
    //             clearTimeout(timeoutId);
    //         }
    //     };
    // }, [otpState.otpVerifyStatus, isActive]);

    return (
        <>
            {
                props.section === "form" && (
                    <Button
                        onClick={() => setSendOtpModal(true)}
                        disabled={props.privacy}
                        label={props.privacy ? "OTP verificato" : "Consenso privacy"}
                        icon={<CheckCircleIcon color={""} size={0} />}
                        size={"md"} iconPosition={props.privacy ? "right" : "off"} variant={props.privacy ? "solid" : "outline"} color={"green"}
                    />
                )
            }
            {
                (props.section === "form" || (
                    props.section === "outcome" && stepOutcome === 1
                )) &&
                <SendOtpModal
                    handleOtpRequest={handleSendOtp}
                    isLoading={isOtpRequestLoading}
                    person={props.person}
                    section={props.section}
                    phone={phone ?? null}
                    setPhone={setPhone}
                    visible={sendOtpModal}
                    onClose={function (): void {
                        setSendOtpModal(false)
                    }}
                />
            }
            {
                (props.section === "form" || (
                    props.section === "outcome" && stepOutcome === 2
                )) &&
                <ConfirmOtpModal
                    handleOtpVerify={handleVerifyOtp}
                    handleOtpRequest={handleSendOtp}
                    isLoading={isOtpVerifyLoading}
                    isError={isOtpVerifyError}
                    isSuccess={isOtpVerifySuccess}
                    section={props.section}
                    phone={phone ?? null}
                    setPhone={setPhone}
                    visible={confirmOtpModal}
                    onClose={function (): void {
                        setConfirmOtpModal(false)
                    }}
                />
            }
        </>
    )
}